<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template v-slot:default="dialog">
      <v-card v-if="device">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
          <v-spacer/>
          <v-btn
            @click="onSyncDevice(device)"
            style="margin-right: 20px;"
          >
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
        <v-card 
          style="margin-bottom: 5px;padding:5px 10px;"
        >
          <small>Nombre:</small><span style="margin-left: 10px;">{{device.Name}}</span>
          <br/>
          <small>Descripción:</small><span style="margin-left: 10px;">{{device.Description}}</span>
          <br/>
          <small>Fecha de última modificación:</small><span style="margin-left: 10px;">{{device.LastModifiedDate}}</span>
          <br/>
          <small>Grupo: </small>
          <v-row no-gutters v-if="device.ReportedGroupID === device.TargetGroupID">
            <v-col
              cols="12"
              sm="12"
            >
              <v-alert
                color="blue"
              >
                {{ device.ReportedGroupName }} 
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters v-else>
            <v-col
              cols="12"
              sm="5"
            >
              <v-alert
                color="grey"
              >
                {{ device.ReportedGroupName }} 
              </v-alert>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              style="text-align:center;padding-top:15px;"
            >
                <v-icon>mdi-arrow-right-bold</v-icon>
            </v-col>
            <v-col
              cols="12"
              sm="5"
            >
              <v-alert
                color="green"
              >
                {{ device.TargetGroupName }}
              </v-alert>
            </v-col>
          </v-row>
          <small>Presentación: </small>
            <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
            >
              <v-alert
                color="orange"
              >
                {{ device.PresentationName }} 
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              v-for="(item, index) of hideButtons"
              :key="`hideButton${index}`"
              cols="12"
              sm="6"
              style="padding: 5px;"
            >
              <v-btn
                block
                :color="device[item.id] === 1 ? 'black' : 'grey'"
                dark
                @click="handleUpdatePlayer(device, item.id)"
              >
                  {{item.name}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
              style="padding: 5px;"
            >
                {{device.ForceReboot === 1 ? '[Pendiente de Reinicio] ' : ''}}
                {{device.ForceRecovery === 1 ? '[Pendiente de Recovery] ' : ''}}
                {{device.ForceReformat === 1 ? '[Pendiente de Reformat] ' : ''}}
            </v-col>
          </v-row>
        </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onUpdatePlayer: {
      type: Function,
      required: true,
    },
    onSyncDevice: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    errors: [],
  }),
  computed: {
    hideButtons () {
      return [
        { id: 'Installation', name: 'Pendiente de instalación' },
        { id: 'Closed', name: 'Temporalmente cerrado' },
        { id: 'Recovery', name: 'Recogida' },
        { id: 'Viewing', name: 'Visionado' },
        { id: 'Missing', name: 'Perdido' },
        { id: 'BackupDevice', name: 'Reserva' },
      ]
    },
  },
  watch: {
    device (v) {
      this.dialog = v ? true : false
    },
  },
  methods:{
    handleClose () {
      this.onClose()
    },
    handleUpdatePlayer(device, type) {
      if (type === 'Installation') {
        device.Installation = device.Installation ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Closed') {
        device.Closed = device.Closed ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Recovery') {
        device.Recovery = device.Recovery ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Viewing') {
        device.Viewing = device.Viewing ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Missing') {
        device.Missing = device.Missing ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'BackupDevice') {
        device.BackupDevice = device.BackupDevice ? false : true
        return this.onUpdatePlayer(device, type)
      }
    },
  },
}
</script>

